<template>
  <MenuPage />
</template>

<script>
import MenuPage from '@/components/MenuPage.vue';

export default {
  name: 'MenuPageView',
  components: {
    MenuPage,
  },
};
</script>